import React from 'react';
import { Button } from '../../../components/ui/button';
import { useAuth0 } from '@auth0/auth0-react';

const Login: React.FC = () => {
  const { loginWithRedirect, isLoading, error } = useAuth0();

  console.log('error', error);

  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-gradient-to-br from-background to-accent/30 dark:from-background dark:to-accent/10">
      <div className="bg-white dark:bg-background rounded-2xl shadow-xl p-8 w-full max-w-md border border-accent/30">
        <h2 className="text-2xl font-bold text-center mb-2 text-foreground">
          Login
        </h2>

        <Button
          variant="outline"
          onClick={() => {
            loginWithRedirect({
              authorizationParams: {
                prompt: 'login',
              },
            });
          }}
          className="w-full"
        >
          {isLoading ? 'Logging in...' : 'Login with Auth0'}
        </Button>
        {error && (
          <div className="text-red-500 mt-4 text-center">
            {error.message || 'An error occurred during login.'}
          </div>
        )}
      </div>
    </div>
  );
};

export default Login;
